/*--------------- Calmcarry Bundle Offer JS ------------------*/
// $(document).ready(function () {
//   setTimeout(function() { 
//   $(".product__color-swatches--inner button.selected").trigger('click');
//     }, 12000);
// });
//  $(document).ready(function () {
//  var DataImg =  $('.product__color-swatches--inner button.selected').attr('data-img-id');
 
// // Find matching slide index
//    setTimeout(function() { 
//   var targetIndex = -1;
//   $('.product__media-item.swiper-slide').each(function (index) {
//     if ($(this).attr('data-media-item-id') == DataImg) {
//       targetIndex = index;
//       return false; // break
//     }
//   });

//   if (targetIndex >= 0) {
//     // Access Swiper instance via DOM element
//     var swiperInstance = document.querySelector('.product__media-container.below-mobile')?.swiper;

//     if (swiperInstance) {
//       swiperInstance.slideTo(targetIndex);
      
//     } else {
//       console.warn('Swiper instance not found');
//     }
//   }
//   }, 1000);   
//  });


// let isAutoRemoving = false;

// $(document).on('click', '.mu-remove-bin', function () {

//   if (isAutoRemoving) return;

//   const mainProductId = '8477609427117';
//   const freeProductId = '8481591918765';

//   let totalQty = 0;

//   $('.mu-cart-item[data-product-id="' + mainProductId + '"]').each(function () {
//     const qtyText = $(this)
//       .find('.mu-item-quantity .mu-px-2')
//       .text()
//       .trim();

//     const qty = parseInt(qtyText, 10);
//     if (!isNaN(qty)) {
//       totalQty += qty;
//     }
//   });

//   if (totalQty < 2) {

//     const freeRemoveBtn = $('.mu-cart-item[data-product-id="' + freeProductId + '"] .mu-remove-bin')[0];

//     if (freeRemoveBtn) {
//       isAutoRemoving = true;
//       freeRemoveBtn.click(); // native click
//       setTimeout(() => {
//         isAutoRemoving = false;
//       }, 500);
//     }
//   }

// });


//  Multivitamin product add to cart

$(document).ready(function () {

  $(".upsell-item").on("click", function () {
    $(".upsell-item").removeClass("active");
    $(this).addClass("active");
  });

  $(".cstm-add-btn").click(function(){
     $("body").addClass("show-loader");

    var VarID = $('.upsell-products .active').attr('data-variant-id');

    var data = {
        id: VarID,
        quantity: 1
    };

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',

        success: function(res) { 
          $(".multi-main-add-btn").trigger('click');
          $("body").removeClass("show-loader");
        },

        error: function(error) {
            console.log(error.responseJSON?.message || 'Error adding to cart');
        }
    });

  });

});



// Supplement_facts_popup

$(document).ready(function () {

  var popupContent = $(".sup-popup-details").html();

  if (popupContent) {
    $(".Supplement_facts_popup").html(popupContent);
  }

  var $popupWrapper = $(".Supplement_facts_popup");
  var $popupPanel = $('[data-drawer-target="panel"]');

  // 👉 OPEN POPUP (delegation use kiya)
  $(document).on("click", ".popup-label", function () {

    $("body").addClass("popup-open");
  });

  // 👉 CLOSE BUTTON
  $(document).on("click", "[data-uw-cer-popup-close]", function () {
    $("body").removeClass("popup-open");
  });

  // 👉 OUTSIDE CLICK
  $popupWrapper.on("click", function (e) {
    if (!$popupPanel.is(e.target) && $popupPanel.has(e.target).length === 0) {
      $("body").removeClass("popup-open");
    }
  });

});




$(document).on("click", ".single-scroller", function () {

  var scrVal = $(this).data("scr"); // e.g. scr-1, scr-2, scr-5

  var delay = 0;

  // 👉 Delay logic
  if (scrVal === "scr-1") {
    delay = 500;
  } else if (scrVal === "scr-2") {
    delay = 1000;
  } else if (scrVal === "scr-3") {
    delay = 1500;
  }

  // 👉 Special case (reviews)
  if (scrVal === "scr-5") {
    setTimeout(function () {
      $('html, body').animate({
        scrollTop: $(".oke-is-large").offset().top
      }, 500);
    }, delay);

    return; // stop further loop
  }

  // 👉 Loop through sections
  $(".scrlr-main").each(function () {

    var targetVal = $(this).data("scrl"); // e.g. scr-1, scr-2

    if (scrVal === targetVal) {

      var targetOffset = $(this).offset().top;

      setTimeout(function () {
        $('html, body').animate({
          scrollTop: targetOffset
        }, 500);
      }, delay);

      return false; // break loop
    }

  });

});



$(document).ready(function() {
  $('.gummies-scroll-btn').on('click', function() {

    
    $('html, body').animate({
      scrollTop: $('#ashwgandha-main-product').offset().top
    }, 800); // 1000 ms = 1 second
  });
});





$(document).ready(function () {
  $(document).on('click', '.on-src-mobile .mobile-dropdown', function () {
    $(".on-src-mobile .faq-menu").toggle('slow');
    $("body").toggleClass('sidebar-open');
  });
});


$(document).on('click','.calm-custom-offer-block-item', function(){
  
  $('.calm-custom-offer-block-item').removeClass('active');
  $(this).addClass('active');
  $('.calm-custom-offer-item-options').hide();
  $(this).find('.calm-custom-offer-item-options').show();
  var dataNumber = $(this).attr('data-number');
  
  $('.calm-custom-offer-btn').attr('data-number', dataNumber);
  
});



$(document).on('click','.calm-custom-offer-btn', function(){
  var VarNum =  $(this).attr('data-number');
   
  var totalVariant = '';
  if (VarNum == 1){
     var VarColor1 =  $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-1 option:selected').val();
     var totalVariant = [VarColor1];

  }
  else if (VarNum == 3){
    var VarColor1 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-1 option:selected').val();
    var VarColor2 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-2 option:selected').val();
    var VarColor3 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-3 option:selected').val();
    var totalVariant = [VarColor1, VarColor2, VarColor3];
   
  }
  else if (VarNum == 5){
    var VarColor1 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-1 option:selected').val();
    var VarColor2 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-2 option:selected').val();
    var VarColor3 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-3 option:selected').val();
    var VarColor4 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-4 option:selected').val();
    var VarColor5 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-5 option:selected').val();
    var totalVariant = [VarColor1, VarColor2, VarColor3, VarColor4, VarColor5];
    
  }
  else if (VarNum == 7){
    var VarColor1 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-1 option:selected').val();
    var VarColor2 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-2 option:selected').val();
    var VarColor3 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-3 option:selected').val();
    var VarColor4 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-4 option:selected').val();
    var VarColor5 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-5 option:selected').val();
    var VarColor6 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-6 option:selected').val();
    var VarColor7 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-7 option:selected').val();
    var totalVariant = [VarColor1, VarColor2, VarColor3, VarColor4, VarColor5, VarColor6, VarColor7];
   
  }

    var data = {
       "id": totalVariant,
       "quantity":1,
  }
  setTimeout(function () {
      $.ajax({
        type: 'POST', 
        url: '/cart/add.js',
        dataType: 'json', 
        data: data,
        success: function() { 
        
          window.monster_refresh(open, data)

        },
        error: function(error) {alert(error.responseJSON.message);}
       });
  }, 1000);

});


$(document).on('click','.calm-custom-buy-btn', function(){
  clearCart();
  var VarNum =  $(this).attr('data-number');
   
  var totalVariant = '';
  if (VarNum == 1){
     var VarColor1 =  $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-1 option:selected').val();
     var totalVariant = [VarColor1];

  }
  else if (VarNum == 3){
    var VarColor1 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-1 option:selected').val();
    var VarColor2 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-2 option:selected').val();
    var VarColor3 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-3 option:selected').val();
    var totalVariant = [VarColor1, VarColor2, VarColor3];
   
  }
  else if (VarNum == 5){
    var VarColor1 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-1 option:selected').val();
    var VarColor2 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-2 option:selected').val();
    var VarColor3 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-3 option:selected').val();
    var VarColor4 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-4 option:selected').val();
    var VarColor5 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-5 option:selected').val();
    var totalVariant = [VarColor1, VarColor2, VarColor3, VarColor4, VarColor5];
    
  }
  else if (VarNum == 7){
    var VarColor1 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-1 option:selected').val();
    var VarColor2 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-2 option:selected').val();
    var VarColor3 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-3 option:selected').val();
    var VarColor4 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-4 option:selected').val();
    var VarColor5 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-5 option:selected').val();
    var VarColor6 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-6 option:selected').val();
    var VarColor7 =   $('.calm-custom-offer-block-item.active .calm-custom-offer-item-options .calm-offer-select-7 option:selected').val();
    var totalVariant = [VarColor1, VarColor2, VarColor3, VarColor4, VarColor5, VarColor6, VarColor7];
   
  }

    var data = {
     "id": totalVariant,
     "quantity":1,
   }
  setTimeout(function () {
      $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: data,
      success: function() { 
        window.location.href = '/checkout';
      },
      error: function(error) {alert(error.responseJSON.message);}
     });
  }, 1000);

});


  

// Essential oils Add to cart
var items = new Array();
$(document).on('click','.essential-oils-add-btn', function(){
    
    $(".essential-product-form-inner input:checked").each(function(){
      var upSell_id =  $(this).val();
      var upitem={};
      upitem['id'] = upSell_id;
      upitem['quantity'] = 1;
      items.push(upitem);
  
    });
    var MainProVAr =  $(this).attr('data-main-val');
    var item={}; 

    item['id'] = MainProVAr;
    item['quantity'] = 1;
    items.push(item);
    addToCartE(items); 

});

  function addToCartE(items)
    {
      jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {items:items},
      dataType: 'json',
      success: function(data) { 
        monster_setCartItems(data.items);
        openCart();
      },
      error: function(error) {alert(error.responseJSON.message);}
      });
    }


/*--------------- Calmcarry New Bundle Offer JS ------------------*/



// setTimeout(function () {
//   var Price = $('.product-custom-block-item.active .product-custom-block-item-right-content').attr('data-price');
//   var ComPrice = $('.product-custom-block-item.active .product-custom-block-item-right-content').attr('data-comapre-price');
//   var Save = $('.product-custom-block-item.active .product-custom-block-item-right-content').attr('data-save');
//   var productId = $('.product-custom-block-item.active').attr('data-product-id');

//   $('.product__details .product__price span.newprice').text(Price);
//   $('.product__details .product__price s.mainprice').text(ComPrice);

//   if(productId != '8482628960429'){
//    $('.product__details .product__price .calm-save-text').text('Save '+ Save);
//   }

// },500);

$(document).on('click','.product-custom-block-item', function(){
  
  $('.product-custom-block-item').removeClass('active');
  $(this).addClass('active');
  var dataNumber = $(this).attr('data-number');
  var productId = $(this).attr('data-product-id');
  $('.product-custom-block-button button').attr('data-number', dataNumber);

  if(dataNumber >= 2 ){
     $('.product-custom-block-free-item').addClass('active');
     $('.product-custom-block-color-options').addClass('active');
  }else{
     $('.product-custom-block-free-item').removeClass('active');
     $('.product-custom-block-color-options').removeClass('active');
  }

  if(dataNumber == 1){
    $('.product-custom-block-color-main').hide();
    $('.product-custom-block-color-main-1').show();
    $('.main-color-heading').text('Select Color :');
    $('.product-custom-block.product-custom-kids-block .product-custom-block-color-options-inner label.main-color-heading').text('Choose Color :');
    
  }
  else if(dataNumber == 2){
    $('.product-custom-block-color-main').hide();
    $('.product-custom-block-color-main-2').show();
    $('.main-color-heading').text('Select Colors :');
    $('.product-custom-block.product-custom-kids-block .product-custom-block-color-options-inner label.main-color-heading').text('Choose Colors :');
  }
  else if(dataNumber == 3){
    $('.product-custom-block-color-main').hide();
    $('.product-custom-block-color-main-3').show();
    $('.main-color-heading').text('Select Colors :');
    $('.product-custom-block.product-custom-kids-block .product-custom-block-color-options-inner label.main-color-heading').text('Choose Colors :');
  }
  $('.product-custom-block-color-options').show();   
  
  
  var Price = $(this).find('.product-custom-block-item-right-content').attr('data-price');
  var ComPrice = $(this).find('.product-custom-block-item-right-content').attr('data-comapre-price');
  var Save = $(this).find('.product-custom-block-item-right-content').attr('data-save');

  $('.product__details .product__price span.newprice').text(Price);
  $('.product__details .product__price s.mainprice').text(ComPrice);
  if(productId != '8482628960429'){
  $('.product__details .product__price .calm-save-text').text('Save '+ Save);
  }
   var Title = $(this).find('.product-custom-block-item-left-content h3').text();
   $('.pack-name').text(Title);
 
  
});

var productSwiper = $('.product__media-container.below-mobile');
 $(document).on('click', '.product-custom-block-colors-item', function () {
   
    var $colorList = $(this).closest('.product-custom-block-colors-list');
    $colorList.find('.product-custom-block-colors-item').removeClass('active');
    $(this).addClass('active');

     var DataImg =  $(this).attr('data-image-id');
     
    // Find matching slide index
      var targetIndex = -1;
      $('.product__media-item.swiper-slide').each(function (index) {
        if ($(this).attr('data-media-item-id') == DataImg) {
          targetIndex = index;
          return false; // break
        }
      });
    
      if (targetIndex >= 0) {
        // Access Swiper instance via DOM element
        var swiperInstance = document.querySelector('.product__media-container.below-mobile')?.swiper;
    
        if (swiperInstance) {
          swiperInstance.slideTo(targetIndex);
        } else {
          console.warn('Swiper instance not found');
        }
      }

     var TargetIndex = -1;
     $('.owl-carousel-16 .product-main-media-item').each(function (Index) {
      if ($(this).attr('data-media-item-id') == DataImg) {
        TargetIndex = Index;
        return false; // break loop
      }
    });
  
    console.log("Index", TargetIndex);
    
    if (TargetIndex >= 0) {
      var sync2Carousel = $('.owl-carousel-16').data('owl.carousel');
        sync2Carousel.to(TargetIndex, 300, true); // Scroll sync2 to thumb

    } else {
      console.warn('No matching media ID found for', DataImg);
    }

   
});

var baseText = 'ADD TO CART';

function showLoader($btn){
  $btn.find('.btn-text').hide();
  $btn.find('.cart--icon').hide(); // hide cart icon
  $btn.find('.loading__spinner_cart').show();
}

function hideLoader($btn){
  $btn.find('.loading__spinner_cart').hide();
  $btn.find('.btn-text').show().html(baseText);
  $btn.find('.cart--icon').show();
}


$(document).on('click','.product-custom-block-btn', function(){
    var $btn = $(this);
    $btn.addClass('disabled');
     
    var VarNum = $btn.attr('data-number');
    var totalVariants = []; // Array of variant IDs for the bundle

    if (VarNum == 1){
        var VarColor1 = $('.product-custom-block-color-main-1 .product-custom-block-colors-list-1 li.product-custom-block-colors-item.active').attr('data-value');
        if(VarColor1) totalVariants.push(VarColor1);
    }
    else if (VarNum == 2){
        var VarColor1 = $('.product-custom-block-color-main-2 .product-custom-block-colors-list-1 li.product-custom-block-colors-item.active').attr('data-value');
        var VarColor2 = $('.product-custom-block-color-main-2 .product-custom-block-colors-list-2 li.product-custom-block-colors-item.active').attr('data-value');
        var VarColor3 = $('.product-custom-block-free-item.active').attr('data-var-id');
        if(VarColor1) totalVariants.push(VarColor1);
        if(VarColor2) totalVariants.push(VarColor2);
        if(VarColor3) totalVariants.push(VarColor3);
    }
    else if (VarNum == 3){
        var VarColor1 = $('.product-custom-block-color-main-3 .product-custom-block-colors-list-1 li.product-custom-block-colors-item.active').attr('data-value');
        var VarColor2 = $('.product-custom-block-color-main-3 .product-custom-block-colors-list-2 li.product-custom-block-colors-item.active').attr('data-value');
        var VarColor3 = $('.product-custom-block-color-main-3 .product-custom-block-colors-list-3 li.product-custom-block-colors-item.active').attr('data-value');
        var VarColor4 = $('.product-custom-block-free-item.active').attr('data-var-id');
        if(VarColor1) totalVariants.push(VarColor1);
        if(VarColor2) totalVariants.push(VarColor2);
        if(VarColor3) totalVariants.push(VarColor3);
        if(VarColor4) totalVariants.push(VarColor4);
    }

    if(totalVariants.length === 0){
        alert("Please select a valid product option.");
        $btn.removeClass('disabled');
        return;
    }

    // Function to add variants to cart sequentially
    function addVariantToCart(index){

        if(index >= totalVariants.length){
            // All variants added
            $btn.removeClass('disabled');
             hideLoader($btn);
            window.monster_refresh(open, totalVariants);
            return;
        }

        var data = {
            id: totalVariants[index],
            quantity: 1
        };

        
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: data,
            beforeSend: function () {
                $btn.addClass('disabled');
                showLoader($btn); // 👈 show spinner
            },
            success: function(){
                addVariantToCart(index + 1);
            },
            error: function(error){
                alert(error.responseJSON ? error.responseJSON.message : "Error adding product to cart");
                $btn.removeClass('disabled');
                hideLoader($btn); // 👈 restore button
            }
        });
    }

    // Start adding the first variant
    addVariantToCart(0);
});

$(document).on('click','.product-custom-sticky-btn', function(){
    $(".product-custom-block-btn").trigger("click");
});



 $(document).on('click', 'body.template-product-calm-mat-new-2 .product__color-swatches--inner button.product__color-swatch', function () {

     var DataImg =  $(this).attr('data-img-id');
  
     var TargetIndex = -1;
     $('.owl-carousel-16 .product-main-media-item').each(function (Index) {
      if ($(this).attr('data-media-item-id') == DataImg) {
        TargetIndex = Index;
        return false; // break loop
      }
    });
  
    console.log("Index", TargetIndex);
    
    if (TargetIndex >= 0) {
      var sync2Carousel = $('.owl-carousel-16').data('owl.carousel');
        sync2Carousel.to(TargetIndex, 300, true); // Scroll sync2 to thumb

    } else {
      console.warn('No matching media ID found for', DataImg);
    }

   
});




/*---------------Product Videos Block Script ------------------*/

$(document).on("click", ".product-video-item", function () {
  var $this = $(this);
  var clickedVideo = $this.find("video").get(0);

  if (clickedVideo.paused) {
    // Play clicked video
    clickedVideo.play();
    $this.find(".play-icon").hide();

    // Pause all other videos
    $(".product-video-item").each(function () {
      var $item = $(this);
      var video = $item.find("video").get(0);

      if (video !== clickedVideo && !video.paused) {
        video.pause();
        $item.find(".play-icon").show();
      }
    });

  } else {
    // Pause clicked video on second click
    clickedVideo.pause();
    $this.find(".play-icon").show();
  }

  // Always ensure play/pause handlers are set
  clickedVideo.onpause = function () {
    $this.find(".play-icon").show();
  };
  clickedVideo.onplay = function () {
    $this.find(".play-icon").hide();
  };
});

// Custom JS
document.addEventListener('DOMContentLoaded', function() {
  // Select the sections
  const announcementBar = document.getElementById('shopify-section-announcement-bar');
  const header = document.getElementById('shopify-section-header');
  const page = document.querySelector('.page'); // select .page element

  // Make sure both exist
  if (announcementBar && header) {
    // Create a wrapper div
    const wrapper = document.createElement('div');
    wrapper.className = 'custom-header-wrapper'; // optional class for styling

    // Insert wrapper before the first section
    announcementBar.parentNode.insertBefore(wrapper, announcementBar);

    // Move both sections into the wrapper
    wrapper.appendChild(announcementBar);
    wrapper.appendChild(header);

    // Add a class to .page after wrapping
    if (page) {
      page.classList.add('page-loaded');
    }
  }
});




/*---------------Product custom Subscription Script ------------------*/


$(document).on('click', '.pack-tab-item', function (e) {
e.preventDefault();
  var $activePack1 = $(this);
  var pack_countc   = parseInt($activePack1.attr('data-pack-count'), 10);
  var per_servingc  = parseInt($activePack1.attr('data-quantity-sr'), 10);
  var total_servingc = pack_countc * per_servingc;

  $('.pack-tab-item').removeClass('active');
  $(this).addClass('active');

  var ProID = $(this).attr('data-pro-id');
  var DataPrice = $(this).attr('data-price');
  var VarID = $(this).attr('data-var-id');

  $('.btn-atc-main .js-total-btn-price').text(DataPrice);
  $('#hidden-variant-id').val(VarID);

  $('.purchase-options-group-item').hide();

  var $activeGroup = $('.purchase-options-group-item[data-pro-id="' + ProID + '"]');
  $activeGroup.show();


  var $onetimeBox = $activeGroup.find('.opt-row-box-onetime');
  var $subscriptionBox = $activeGroup.find('.opt-row-box-subscription');

  if ($onetimeBox.hasClass('active')) {
    $('#hidden-plan-id').val('');
  }

  if ($subscriptionBox.hasClass('active')) {

   


var subs_price = $subscriptionBox.find('.js-sub-price-new').text();
var nums = subs_price.match(/[\d,.]+/g);
subs_price = nums ? parseFloat(nums[nums.length - 1].replace(/,/g, '')) : 0;

var perserving_pricec = subs_price / total_servingc;
perserving_pricec = perserving_pricec.toFixed(2);
$(".selected-item-serv").text(total_servingc);
$(".selected-item-price").text(perserving_pricec);







    var $subInfo = $subscriptionBox.find('.subscription-expanded-info');
    var selectedPlanId = $subscriptionBox
      .find('.js-frequency-selector option:selected')
      .val();

    $subInfo.show();
    $('#hidden-plan-id').val(selectedPlanId);
    var subs_pricebtn = $subscriptionBox.find('.js-sub-price-new').text();
    $('.btn-atc-main .js-total-btn-price').text(subs_pricebtn);

    var latest_plan_id = $subscriptionBox.find('.delivery-frequency-plan-list li:first').attr('plan-id');
     $('#hidden-plan-id').attr('value', latest_plan_id);

     $('.delivery-frequency-selected span').text('');

     var selectedText = "";
var firstText = "";

$subscriptionBox
  .find(".delivery-frequency-wrapper .delivery-frequency-plan-list li")
  .each(function (index) {

    if (index === 0) {
      firstText = $(this).text().trim();
    }

    if ($(this).hasClass("active")) {
      selectedText = $(this).text().trim();
    }

  });
if (!selectedText) {
  selectedText = firstText;
}

$('.delivery-frequency-selected span').text(selectedText);



    // $(".opt-row-box-subscription .delivery-frequency-wrapper .delivery-frequency-plan-list").hide();
    // $subscriptionBox.find(".opt-row-box-subscription .delivery-frequency-wrapper .delivery-frequency-plan-list").show();

  }else{
    $onetimeBox.addClass('active');
    var onetime_price = $onetimeBox.attr('data-price');
    var nums2 = onetime_price.match(/[\d,.]+/g);
    onetime_price = nums2 ? parseFloat(nums2[nums2.length - 1].replace(/,/g, '')) : 0;
    var perserving_priceo = onetime_price / total_servingc;
    perserving_priceo = perserving_priceo.toFixed(2);
     $(".selected-item-serv").text(total_servingc);
    $(".selected-item-price").text(perserving_priceo);
    var onetime_price_btn = $onetimeBox.attr('data-price');
    $('.btn-atc-main .js-total-btn-price').text(onetime_price_btn);
  }
});


// price calculation on load
 
setTimeout(function() {
var $activePack = $('.pack-tab-item.active');

var pack_count   = parseInt($activePack.attr('data-pack-count'), 10);
var per_serving  = parseInt($activePack.attr('data-quantity-sr'), 10);
var total_serving = pack_count * per_serving;

var price_all = $('.opt-row-box-subscription.active')
  .find('[data-price]')
  .attr('data-price');
var currency_icon = (price_all.match(/^[^\d]+|[^\d]+$/g) || []).join('').trim();
$(".currency_symbel").text(currency_icon);
var nums3 = price_all.match(/[\d,.]+/g);
price_all = nums3 ? parseFloat(nums3[nums3.length - 1].replace(/,/g, '')) : 0;

var perserving_price = price_all / total_serving;
perserving_price = perserving_price.toFixed(2);
$(".selected-item-serv").text(total_serving);
$(".selected-item-price").text(perserving_price);
 }, 500);



// Quantity slector js


$(document).on('click', '.purchase-box-v3 .js-qty-plus', function () {

  const $box = $(this).closest('.purchase-box-v3');
  const $qtyInput = $box.find('.js-qty-input');
  const $hiddenQty = $box.find('#hidden-qty');

  let qty = parseInt($qtyInput.val(), 10) || 1;
  qty++;

  $qtyInput.val(qty);
  $hiddenQty.val(qty);
});

$(document).on('click', '.purchase-box-v3 .js-qty-minus', function () {

  const $box = $(this).closest('.purchase-box-v3');
  const $qtyInput = $box.find('.js-qty-input');
  const $hiddenQty = $box.find('#hidden-qty');

  let qty = parseInt($qtyInput.val(), 10) || 1;

  if (qty > 1) {
    qty--;
  }
 $qtyInput.val(qty);
  $hiddenQty.val(qty);

});



$(document).on('click','.opt-radio-row-top-1', function(e){
  e.preventDefault();
  $('.opt-radio-row-top-1').removeClass('active');
  $(this).addClass('active');
  var DataType = $(this).attr('data-type');
  var DataPrice = $(this).attr('data-price');
  var selectedPlan  = $('.delivery-frequency-wrapper select option:selected').val();

  var $activePack2 = $('.pack-tab-item.active');

  var pack_count2   = parseInt($activePack2.attr('data-pack-count'), 10);
  var per_serving2  = parseInt($activePack2.attr('data-quantity-sr'), 10);
  var total_serving2 = pack_count2 * per_serving2;

  if (DataType == 'subscription'){
    $(".opt-row-box-subscription").addClass('active');
     $('.subscription-expanded-info').show();
     $('.btn-atc-main .js-total-btn-price').text(DataPrice);
      $('#hidden-plan-id').val(selectedPlan);
      $subscriptionBox = $(".opt-row-box-subscription .active")
    var subs_price2 = $subscriptionBox.find('.js-sub-price-new').text();
    var nums4 = subs_price2.match(/[\d,.]+/g);
    subs_price2 = nums4 ? parseFloat(nums4[nums4.length - 1].replace(/,/g, '')) : 0;

    var perserving_pricec2 = subs_price2 / total_serving2;
    perserving_pricec2 = perserving_pricec2.toFixed(2);
    $(".selected-item-serv").text(total_serving2);
    $(".selected-item-price").text(perserving_pricec2);
  }
  else{
    $('.btn-atc-main .js-total-btn-price').text(DataPrice);
    $('.subscription-expanded-info').hide();
    $(".opt-row-box-subscription").removeClass('active');
     $('#hidden-plan-id').val('');
     $onetimeBox1 = $(".opt-row-box-onetime.active .js-onetime-price-display");
     var onetime_price2 = $onetimeBox1.text();
     var nums5 = onetime_price2.match(/[\d,.]+/g);
    onetime_price2 = nums5 ? parseFloat(nums5[nums5.length - 1].replace(/,/g, '')) : 0;
    var perserving_priceo2 = onetime_price2 / total_serving2;
    var perserving_priceo21 = perserving_priceo2.toFixed(2);
     $(".selected-item-serv").text(total_serving2);
    $(".selected-item-price").text(perserving_priceo21);
  }

  

});



$(document).on('click', 'ul.delivery-frequency-plan-list li.plan-item', function () {
   $("li.plan-item").removeClass('active');
   $(this).addClass('active');
   $('.delivery-frequency-plan-list').hide();
   var selectedPlanId = $(this).attr('plan-id');
   var selectedPlanName = $(this).text();
   $('#hidden-plan-id').val(selectedPlanId);
   $('.delivery-frequency-selected span').text(selectedPlanName);
   
});

$(document).on('click', function (e) {
  if (!$(e.target).closest('.delivery-frequency-wrapper').length) {
    $('.delivery-frequency-plan-list').hide();
  }
});



$(document).on('click', '.delivery-frequency-selected', function () {
  $(this).toggleClass('active');
  $(this).next('.delivery-frequency-plan-list').toggle();
   
});





/*--------------- Price change on Quantity start ------------------*/


function updatePrice(parent) {

    var priceEl = parent.find('.js-total-btn-price');

    var basePrice = parseFloat(priceEl.attr('data-base-price'));
    var currency = priceEl.attr('data-currency');

    if (!basePrice) {
        var priceText = priceEl.text().trim();

        currency = priceText.replace(/[\d.,]/g, '').trim();
        basePrice = parseFloat(priceText.replace(/[^\d.]/g, ''));

        priceEl.attr('data-base-price', basePrice);
        priceEl.attr('data-currency', currency);
    }

    var qty = parseInt(parent.find('.js-qty-input').val()) || 1;

    var total = basePrice * qty;

    priceEl.text(currency + total.toFixed(2));
}


$(document).on('click', '.js-qty-plus, .js-qty-minus', function () {
    var parent = $(this).closest('form, .product, .product-wrapper');
    updatePrice(parent);
});


$(document).on('click', '.opt-radio-row-top-1', function () {

    var parent = $(this).closest('form, .product, .product-wrapper');
    var priceEl = parent.find('.js-total-btn-price');

    setTimeout(function () {

        var priceText = priceEl.text().trim();

        var currency = priceText.replace(/[\d.,]/g, '').trim();
        var basePrice = parseFloat(priceText.replace(/[^\d.]/g, ''));

        priceEl.attr('data-base-price', basePrice);
        priceEl.attr('data-currency', currency);

        updatePrice(parent);

    }, 100);
});


$(document).on('click', '.pack-tab-item', function () {

    var parent = $(this).closest('form, .product, .product-wrapper');
    var priceEl = parent.find('.js-total-btn-price');

    setTimeout(function () {

        var priceText = priceEl.text().trim();

        var currency = priceText.replace(/[\d.,]/g, '').trim();
        var basePrice = parseFloat(priceText.replace(/[^\d.]/g, ''));

        priceEl.attr('data-base-price', basePrice);
        priceEl.attr('data-currency', currency);

        updatePrice(parent);

    }, 100);
});



/*--------------- Price change on Quantity end ------------------*/





/*--------------- Gummies Add to cart AJAX------------------*/

$(document).on('click', '.btn-atc-main', function(e){
    e.preventDefault(); // 🚨 stop form submit

    var $btn = $(this);

    // Prevent double click
    if ($btn.hasClass('disabled')) return;

    var $text = $btn.find('.btn-atc-main-text');
    var $loader = $btn.find('.btn-loader');

    // Show loader
    $btn.addClass('disabled');
    $text.hide();
    $loader.show();

    var VarID = $('#hidden-variant-id').val();
    var VarPlanID = $('#hidden-plan-id').val();

    var data = {
        id: VarID,
        quantity: 1
    };

    // Only add selling_plan if exists
    if (VarPlanID) {
        data.selling_plan = VarPlanID;
    }

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',

        success: function(res) { 
          window.monster_refresh(open, data) // your cart drawer function
        },

        error: function(error) {
            alert(error.responseJSON?.message || 'Error adding to cart');
        },

        complete: function() {
            // Hide loader (always runs)
            $btn.removeClass('disabled');
            $text.show();
            $loader.hide();
        }
    });
});
